import React from "react";
import { STATUSES } from "@/lib/api";
import {
  FileText, Search, Send, Landmark, Inbox, Sparkles,
  ShieldCheck, Coins, PartyPopper, Play,
} from "lucide-react";

const STATUS_ICONS = {
  "Getting Started": FileText,
  "Credit Analysis": Search,
  "Disputes Submitted": Send,
  "Bureau Processing": Landmark,
  "Results Coming In": Inbox,
  "Credit Optimization": Sparkles,
  "Funding Ready": ShieldCheck,
  "Funding in Progress": Coins,
  "Completed": PartyPopper,
  "Completed After 30 Days": PartyPopper,
};

export default function PizzaTracker({ status, startDate }) {
  const isThirtyDay = status === "Completed After 30 Days";
  const effectiveList = STATUSES;
  const activeIdx = isThirtyDay
    ? STATUSES.length - 1
    : Math.max(0, STATUSES.indexOf(status));
  const progressPct = ((activeIdx) / (STATUSES.length - 1)) * 100;

  return (
    <div className="w-full" data-testid="pizza-tracker">
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-slate-400">
            Live Progress<span> · </span>
            <span
              onClick={() => window.dispatchEvent(new CustomEvent("cq:open-secret"))}
              className="cursor-default select-none"
              aria-hidden="true"
              data-testid="pizza-secret-trigger"
            >Credit</span> Tracker
          </p>
          <h3 className="text-2xl font-black text-slate-900 font-display">
            {isThirtyDay ? "Completed After 30 Days" : status}
          </h3>
        </div>
        {isThirtyDay && (
          <span className="inline-flex items-center gap-1 rounded-full bg-green-100 px-3 py-1 text-xs font-bold text-green-700">
            <PartyPopper size={14} /> 30-Day Milestone
          </span>
        )}
      </div>

      <div className="relative py-6 overflow-x-auto scrollbar-hide">
        <div className="relative min-w-[900px] px-4">
          {/* Background line */}
          <div className="absolute top-[38px] left-4 right-4 h-2 bg-slate-200 rounded-full" />
          {/* Fill line */}
          <div
            className="absolute top-[38px] left-4 h-2 bg-amber-500 rounded-full transition-all duration-700"
            style={{ width: `calc(${progressPct}% * (100% - 32px) / 100)` }}
          />

          <div className="relative flex justify-between">
            {effectiveList.map((s, idx) => {
              const state =
                idx < activeIdx
                  ? "completed"
                  : idx === activeIdx
                  ? "active"
                  : "upcoming";
              const Icon = STATUS_ICONS[s] || Play;
              const cls = {
                completed: "bg-green-500 text-white shadow-green-200",
                active: "bg-amber-500 text-white shadow-amber-200 cq-pulse",
                upcoming: "bg-white text-slate-400 border-2 border-slate-200",
              }[state];
              return (
                <div
                  key={s}
                  className="flex flex-col items-center gap-2 min-w-[80px]"
                  data-testid={`tracker-step-${s.toLowerCase().replace(/ /g, "-")}`}
                >
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center border-4 border-white shadow-lg ${cls}`}>
                    <Icon size={20} strokeWidth={state === "active" || state === "completed" ? 2.5 : 2} />
                  </div>
                  <span className={`text-xs font-bold text-center leading-tight ${state === "upcoming" ? "text-slate-400" : "text-slate-800"}`}>
                    {s}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
